import { ReactNode } from 'react'
import connectConditionalResults from '../../Connectors/statsConnector'

type PropTypes = {
  children: ReactNode
  nbHits: number
  onSearchResults: (props: PropTypes) => void
}

const FilterResults = (props: PropTypes) => {
  const { children, nbHits, onSearchResults } = props

  if (onSearchResults) {
    onSearchResults(props)
  }

  return nbHits ? children : null
}

export default connectConditionalResults(FilterResults)
